/**
 * Created by zhaoyue on 2020/7/13 7:11 下午
 * axios 实例
 */

import axios from "axios";
import { Toast } from "vant";
import { getJwtSafeCode, getToken } from "@/libs/utils";

// 默认超时配置
axios.defaults.timeout = 20000;

// 默认请求域名
// if (process.env.NODE_ENV.startsWith("dev_")) {
//   axios.defaults.baseURL = `${location.origin}/${process.env.VUE_APP_PROXY_PREFIX}`;
// } else {
//   axios.defaults.baseURL = `${location.origin}/backendapi`;
// }

console.log("现在环境 NODE_ENV : " + process.env.NODE_ENV);

// http request 拦截器
axios.interceptors.request.use(
  (config: any) => {
    // 获取jwt
    const jwt = getJwtSafeCode();
    // 获取token
    const token = getToken();
    if (config.prefix) {
      config.baseURL = `${location.origin}/${
        process.env["VUE_APP_" + config.prefix]
      }`;
    } else {
      config.baseURL = `${location.origin}/${process.env.VUE_APP_BackendApi}`;
    }
    //普通接口调用
    if (!config.noJwt) {
      config.headers["GOFUNAUTHORIZATION"] = token;
      config.headers["AUTHORIZATION"] = jwt;
    }
    if (!config.noLoading) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true // 背景禁止点击
      });
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response: any) => {
    if (!response.config.noLoading) {
      Toast.clear();
    }
    //除去 200成功状态 和 190808网关降级状态的 code码，其他都当失败处理，会toast错误说明
    if (
      !response.config.noToast &&
      // response.data &&
      // response.data.code &&
      response.data.code !== 200 &&
      response.data.code !== 190808
    ) {
      Toast(response.data.desc);
    }
    if (response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  },
  error => {
    Toast.clear();
    Toast("系统出了点小问题，请稍后重试");
    return Promise.reject(error);
  }
);

export default axios;
